{
  "endTime": "Befejezés ideje",
  "startTime": "Kezdés ideje",
  "time": "Idő"
}
